import useComponentSize from '@rehooks/component-size';
import { RefObject, useCallback, useMemo, useState } from 'react';

import { People } from '~/services/Http';

export interface UseContentOutput {
  fullAnnouncement?: People.CompanyPostDto;
  handleReadMoreButtonClick: (id: number) => void;
  handleAnnouncementDialogClose: () => void;
}

export const useContent = (
  onReadMoreDialogOpen: () => void,
  onReadMoreDialogClose: () => void,
  ref: RefObject<HTMLSpanElement>,
  announcements?: People.CompanyPostDto[],
): UseContentOutput => {
  const [fullAnnouncementId, setFullAnnouncementId] = useState<
    number | undefined
  >(undefined);

  // used for rerendering in case of resizing
  useComponentSize(ref);

  const handleReadMoreButtonClick = useCallback(
    (id: number) => {
      onReadMoreDialogOpen();
      setFullAnnouncementId(id);
    },
    [setFullAnnouncementId, onReadMoreDialogOpen],
  );

  const handleAnnouncementDialogClose = useCallback(() => {
    onReadMoreDialogClose();
    setFullAnnouncementId(undefined);
  }, [setFullAnnouncementId, onReadMoreDialogClose]);

  const fullAnnouncement = useMemo(
    () => announcements?.find((a) => a.id === fullAnnouncementId)!,
    [announcements, fullAnnouncementId],
  );

  return {
    fullAnnouncement,
    handleReadMoreButtonClick,
    handleAnnouncementDialogClose,
  };
};
